import React, { useState, useContext, useEffect } from "react";
import FilterShops from "./FilterShops";
import { FormContext } from "../context/FormContext";

const SearchResultsTienda = ({filteredResults, setFilteredResults, results, onHover, onSelect }) => {
  const { updateFormData, formData } = useContext(FormContext);
  const [activeHorarioIndex, setActiveHorarioIndex] = useState(null);

  useEffect(() => {
    if (results && Array.isArray(results)) {
      setFilteredResults(results);
    } else {
      setFilteredResults([]);
    }
  }, [results, setFilteredResults]);


  const handleSelect = (result) => {

    try {
      if (!result.servicio || result.servicio.length === 0) {
        console.error("La tienda seleccionada no tiene servicios disponibles.");
        alert("La tienda seleccionada no tiene servicios disponibles.");
        return; // Detén la ejecución si no hay servicios
      }
  
      updateFormData({
        TiendaSeleccionada: {
          nombre: result.descripcion,
          direccion: result.direccion,
          cfg_codigo: result.cfg_codigo,
          servicios: result.servicio, // Incluye los servicios
          cfg_latitud: result.cfg_latitud,
          cfg_longitud: result.cfg_longitud
        },
      });
  
      // console.log("Tienda seleccionada agregada al contexto:", {
      //   nombre: result.descripcion,
      //   direccion: result.direccion,
      //   cfg_codigo: result.cfg_codigo,
      //   servicios: result.servicio,
      // });
      onSelect(result); // Avanzar al siguiente paso
    } catch (error) {
      console.error("Error al agregar la tienda al contexto:", error);
    }
  };

  const toggleHorario = (index) => {
    setActiveHorarioIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="col-12 store-selector-list pads0">
      {results && results.length > 0 ? (
        <>
          <div className="row">
            <FilterShops
              results={results}
              setFilteredResults={setFilteredResults}
            />
          </div>
          <div className="row">
            {filteredResults.map((result, index) => (
              <div
                key={result.cfg_codigo}
                className="col-12 store-box"
                onMouseEnter={() => onHover(result)}
              >
                <h5 className="searchstore-name">{result.descripcion}</h5>
                <p className="searchstore-address">

                  {result.direccion}, {result.ubg_denominacion}, {result.dpt_descripcion}
                </p>

                <p className="searchstore-info">
                 
                <u style={{ textDecoration: "none" }}>600 822 02 00</u>
          
                  <br className="show-992" />
                  <span className="hide-992">&nbsp;&nbsp;</span>
<a
  href={
    result.cfg_latitud && result.cfg_longitud // Verificar que ambas coordenadas existan
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          `${result.cfg_latitud.replace(",", ".")},${result.cfg_longitud.replace(",", ".")}`
        )}`
      : "#"
  }
  target="_blank"
  rel="noopener noreferrer"
  onClick={(e) => {
    if (!result.cfg_latitud || !result.cfg_longitud) {
      e.preventDefault(); // Evitar que el enlace intente navegar si no hay coordenadas válidas
      console.warn("Las coordenadas no están disponibles.");
    }
  }}
>
  &nbsp; <u>Cómo llegar</u>
</a>


                  &nbsp;
                  {/* <span>
                    <i className="fa fa-map-marker"></i> 4.2km
                  </span> */}
                </p>

                {/* <div>
                  <p
                    className="opening-hours-trigger cpointer inline-b"
                    onClick={() => toggleHorario(index)}
                  >
                    Horarios de la tienda <i className="fa fa-angle-down"></i>
                  </p>
                  {activeHorarioIndex === index && (
                    <ul className="pl0 opening-hours">
                      <li>
                        <p className="mb0">
                          Lun. &nbsp;&nbsp;&nbsp; <span>10:00am</span> -{" "}
                          <span>07:00pm</span>
                        </p>
                      </li>
                      <li>
                        <p className="mb0">
                          Mar. &nbsp;&nbsp;&nbsp; <span>10:00am</span> -{" "}
                          <span>07:00pm</span>
                        </p>
                      </li>
                    
                    </ul>
                  )}
                </div> */}

                <div className="img-big">
                  <a
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                   
                      transition: "color 0.3s ease",
                    }}
                    className={` searchstore-submit upper h6-less ${formData?.cadena === 'eco' ? "searchstore-submit-eco" : ""}
                    ${formData?.cadena === 'gmo' ? "searchstore-submit-gmo" : ""}`}
                    onClick={() => handleSelect(result)}
                  >
                    Programar Examen
                  </a>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="text-center">No se encontraron resultados.</p>
      )}
    </div>
  );
};

export default SearchResultsTienda;
